import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Hidden } from '@material-ui/core';
import { HSpacer } from '..';

var styles = function styles() {
  return {
    container: {
      height: '47px',
      borderBottom: '1px solid #D7DAE2',
      borderTop: '1px solid #D7DAE2',
      width: '100%'
    }
  };
};

var SingleLine = function SingleLine(props) {
  var childArray = React.Children.toArray(props.children);
  return React.createElement(Grid, {
    container: true,
    className: props.classes.container,
    alignItems: 'center'
  }, React.createElement(Grid, {
    container: true,
    alignItems: 'center'
  }, (childArray || []).filter(function (ch) {
    return ch !== undefined && ch !== null && ch !== false;
  }).map(function (child, index) {
    return React.createElement(React.Fragment, {
      key: index
    }, index > 0 && React.createElement(Hidden, {
      only: ['xs', 'sm', 'md']
    }, React.createElement(HSpacer, {
      large: true
    })), index > 0 && React.createElement(Hidden, {
      only: ['lg', 'xl']
    }, React.createElement(HSpacer, {
      medium: true
    })), child);
  })));
};

export default withStyles(styles)(SingleLine);